import { Type } from '@angular/core';
import { ExtendedRankSortQuestionType, ExtendedRatingQuestionType, QuestionType } from '@empathy/survey/base';

import { NotepadAvailableTypes } from './notepad-question-type.constant';
import { CarouselFormComponent } from '../components/carousel-form/carousel-form.component';
import { ChoicesFormComponent } from '../components/choices-form/choices-form.component';
import { RanksFormComponent } from '../components/ranks-form/ranks-form.component';

export const NotepadQuestionTypeFormComponent: Record<NotepadAvailableTypes, Type<any>> = {
  [QuestionType.Carousel]: CarouselFormComponent,
  [QuestionType.CarouselMultiChoice]: CarouselFormComponent,
  [QuestionType.Dropdown]: ChoicesFormComponent,
  [QuestionType.Essay]: undefined,
  [QuestionType.MultiChoice]: ChoicesFormComponent,
  [QuestionType.SingleChoice]: ChoicesFormComponent,
  [QuestionType.Heatmap]: undefined,
  [QuestionType.InfoPage]: undefined,
  [QuestionType.FileUpload]: undefined,
  [QuestionType.Input]: undefined,
  [QuestionType.Terminate]: undefined,
  [QuestionType.NPS]: undefined,
  [QuestionType.Ranking]: ChoicesFormComponent,
  [ExtendedRankSortQuestionType.RankSortNumeric]: ChoicesFormComponent,
  [ExtendedRankSortQuestionType.RankSortDescriptive]: RanksFormComponent,
  [ExtendedRatingQuestionType.RatingNumeric]: undefined,
  [ExtendedRatingQuestionType.RatingDescriptive]: ChoicesFormComponent,
  [ExtendedRatingQuestionType.RatingStars]: undefined
};
